// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-link.--exact-active[data-v-0e06a7cc]{--tw-bg-opacity:1;background-color:#0e0e0e;background-color:rgba(14,14,14,var(--tw-bg-opacity));--tw-text-opacity:1;color:#fafafa;color:rgba(250,250,250,var(--tw-text-opacity))}[snippet-menu].is-small[data-v-0e06a7cc] li a.--active{--tw-border-opacity:1;border-color:#fafafa;border-color:rgba(250,250,250,var(--tw-border-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
